import { render, staticRenderFns } from "./state.vue?vue&type=template&id=70ff8d4d&scoped=true&"
import script from "./state.vue?vue&type=script&lang=js&"
export * from "./state.vue?vue&type=script&lang=js&"
import style0 from "./state.vue?vue&type=style&index=0&id=70ff8d4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ff8d4d",
  null
  
)

component.options.__file = "state.vue"
export default component.exports